import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaCogs, FaRobot, FaTools, FaBalanceScale, FaLaptop,
  FaTruck, FaWrench, FaBox, FaBolt, FaCheckCircle
} from 'react-icons/fa';

const Servicios = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [servicioSeleccionado, setServicioSeleccionado] = useState('');

  const servicios = [
    { name: "Ingeniería Mecánica", icon: <FaCogs /> },
    { name: "Ingeniería Eléctrica", icon: <FaBolt /> },
    { name: "Mantenimiento Industrial", icon: <FaWrench /> },
    { name: "Metrología", icon: <FaBalanceScale /> },
    { name: "Automatización", icon: <FaRobot /> },
    { name: "Desarrollo de Software", icon: <FaLaptop /> },
    { name: "Logística y Transporte", icon: <FaTruck /> },
    { name: "Venta de repuestos y equipos", icon: <FaBox /> }
  ];

  const descripciones = {
    "Ingeniería Mecánica": [
      "Montaje mecánico de maquinaria",
      "Montaje de equipos de aire acondicionado",
      "Montaje de estructuras metálicas"
    ],
    "Ingeniería Eléctrica": [
      "Instalaciones eléctricas",
      "Mantenimiento de sistemas eléctricos",
      "Automatización de procesos"
    ],
    "Mantenimiento Industrial": [
      "Mantenimiento preventivo de maquinaría",
      "Mantenimiento correctivo de equipos",
      "Planificación de mantenimiento industrial"
    ],
    "Metrología": [
      "Calibración de equipos de masa y balanzas",
      "Certificación de equipos",
      "Asesoría en trazabilidad"
    ],
    "Automatización": [
      "Programación de arduino y Rasperry Pi",
      "Integración de sensores y actuadores",
      "Software para control, automatización y toma de datos"
    ],
    "Desarrollo de Software": [
      "Aplicaciones web personalizadas",
      "Sistemas ERP",
      "Automatización de procesos digitales"
    ],
    "Logística y Transporte": [
      "Entrega de mercancias y equipos",
      "Optimización de entregas",
      "Servicios de transporte técnico"
    ],
    "Venta de repuestos y equipos": [
      "Venta de equipos industriales",
      "Suministro de repuestos certificados",
      "Asistencia técnica postventa"
    ]
  };

  const fondoColor = '#001f3f';
  const textoBlanco = { color: 'white', textAlign: 'center' };

  // 🧠 Hook para cerrar modal con Esc y bloquear scroll
  useEffect(() => {
    if (modalVisible) {
      document.body.style.overflow = 'hidden'; // Bloquear scroll

      const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
          setModalVisible(false);
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.body.style.overflow = ''; // Restaurar scroll
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [modalVisible]);

  return (
    <section id="servicios" style={{ padding: '4rem 1rem', background: '#fff' }}>
      <h2 style={{ textAlign: 'center' }}>Nuestros Servicios</h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '2rem' }}>
        {servicios.map((serv) => (
          <motion.div
            key={serv.name}
            whileHover={{ scale: 1.05 }}
            onClick={() => {
              setServicioSeleccionado(serv.name);
              setModalVisible(true);
            }}
            style={{
              background: fondoColor,
              color: 'white',
              margin: '1rem',
              padding: '2rem',
              borderRadius: '10px',
              width: '200px',
              textAlign: 'center',
              cursor: 'pointer'
            }}
          >
            <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>{serv.icon}</div>
            <p>{serv.name}</p>
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {modalVisible && servicioSeleccionado && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: fondoColor,
                color: 'white',
                padding: '2rem',
                borderRadius: '15px',
                width: '90%',
                maxWidth: '500px',
                textAlign: 'center',
                position: 'relative'
              }}
            >
              <button
                onClick={() => setModalVisible(false)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '15px',
                  background: 'transparent',
                  border: 'none',
                  color: 'white',
                  fontSize: '1.2rem',
                  cursor: 'pointer'
                }}
              >
                ✖
              </button>

              <h3 style={{
                marginBottom: '1.5rem',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}>
                <span style={{ fontSize: '1.8rem' }}>
                  {servicios.find(s => s.name === servicioSeleccionado)?.icon}
                </span>
                {servicioSeleccionado}
              </h3>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {descripciones[servicioSeleccionado].map((item, index) => (
                  <li
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '0.8rem',
                      ...textoBlanco
                    }}
                  >
                    <FaCheckCircle style={{ color: 'limegreen', marginRight: '0.5rem' }} />
                    <span style={{ fontWeight: 'bold' }}>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Servicios;
